<template>
  <div>
    <v-icon @click="dialog = true" color="red">mdi-delete</v-icon>

    <SysDialog
      v-model="dialog"
      :titulo="'Deletar o menu: ' + editar_item.id + ' - ' + editar_item.descricao + '?'"
      txtBotao="Deletar"
      cor_do_botao="red"
      @click:primary="deletarMenu()"
    >
      <span />
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import Form from './Includes/_form.vue';
import { deletarMenusConfiguracaoMenuParametrizacao } from '../../Api';

export default {
  components: {
    SysDialog,
    Form
  },
  model: {
    prop: 'editar_item',
    event: 'change-editar'
  },
  props: {
    editar_item: {
      type: Object
    }
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    fecharDialog() {
      this.dialog = false;
    },
    deletarMenu() {
      this.$store.dispatch(
        'loading/addRequisicao',
        deletarMenusConfiguracaoMenuParametrizacao(this.editar_item)
          .then(() => this.$emit('atualizar-tela-inicial-menu-configuracao-menu'))
          .catch(() => this.Helpers.logout())
          .finally(() => this.fecharDialog())
        );
    },
  }
}
</script>

<style>

</style>
